export const RICH_TEXT_COLOR_PALETTE = [
  '#f8fafc',
  '#e2e8f0',
  '#94a3b8',
  '#38bdf8',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
  '#a855f7'
];

export const RICH_TEXT_HIGHLIGHT_PALETTE = [
  '#fef9c3',
  '#dcfce7',
  '#dbeafe',
  '#fce7f3',
  '#fde68a',
  '#fecaca'
];
